import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the RoomCustomerProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class RoomCustomerProvider {

  constructor(public http: HttpClient) {
    console.log('Hello RoomCustomerProvider Provider');
  }

}



// WEBPACK FOOTER //
// ./src/providers/room-customer/room-customer.ts